export const SMS_CAMPAIGNS_RESET_STATE = 'SMS_CAMPAIGNS_RESET_STATE';
export const SMS_CAMPAIGNS_CURRENT_ITEM = 'SMS_CAMPAIGNS_CURRENT_ITEM';

export const SMS_CAMPAIGNS_REQUEST_LOADING = 'SMS_CAMPAIGNS_REQUEST_LOADING';
export const SMS_CAMPAIGNS_REQUEST_SUCCESS = 'SMS_CAMPAIGNS_REQUEST_SUCCESS';
export const SMS_CAMPAIGNS_REQUEST_FAILED = 'SMS_CAMPAIGNS_REQUEST_FAILED';

export const SMS_CAMPAIGNS_CURRENT_ACTION = 'SMS_CAMPAIGNS_CURRENT_ACTION';
export const SMS_CAMPAIGNS_RESET_ACTION = 'SMS_CAMPAIGNS_RESET_ACTION';
